import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-send-button",
  "use": "svgIcon-send-button-usage",
  "viewBox": "0 0 535.5 535.5",
  "content": "<symbol viewBox=\"0 0 535.5 535.5\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-send-button\"><path d=\"m0 497.3 535.5-229.5-535.5-229.5v178.5l382.5 51-382.5 51z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol